<template>
  <v-row justify="center">
    <v-card>
      <v-card-title>Create / Edit Sub Menu</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="width: 600px">
        <div class="row">
          <v-col cols="12" sm="3" class="label">
            <label>Service* :</label>
          </v-col>
          <v-col cols="12" sm="8">
            <select-option :items="services" @update="updateService" :model="form.service_id" />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3" class="label">
            <label>Sub menu TH* :</label>
          </v-col>
          <v-col cols="12" sm="8">
            <input-text-field :model="form.title_th" @update="updateMenuTH" />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3" class="label">
            <label>Sub menu EN* :</label>
          </v-col>
          <v-col cols="12" sm="8">
            <input-text-field :model="form.title_en" @update="updateMenuEN" />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3" class="label">
            <label>Slug Url :</label>
          </v-col>
          <v-col cols="12" sm="8">
            <input-text-field :model="form.slug_url" @update="updateSlugUrl" />
          </v-col>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <div class="row text-right">
        <v-spacer></v-spacer>
        <cancel-button @click.native="cancelData" />
        <save-button @click.native="submitData" />
      </div>
      <br />
    </v-card>
  </v-row>
</template>

<script>
import InputEditor from "../../../components/Input/InputEditor";
import InputTextField from "../../../components/Input/InputTextField";
import SelectOption from "../../../components/Input/selectOption";
import { mapState } from "vuex";
import SaveButton from "../../../components/Button/SaveButton";
import CancelButton from "../../../components/Button/CancelButton";
import Swal from "sweetalert";
export default {
  name: "CreateSubMenuModal",
  components: { CancelButton, SaveButton, SelectOption, InputTextField, InputEditor },
  props: {
    services: Array
  },
  data() {
    return {
      optionMenu: [],
      optionService: []
    };
  },
  computed: {
    ...mapState({
      form: state => {
        return state.SubMenu.form;
      }
    })
  },
  methods: {
    getServiceData() {
      this.$store.dispatch("Services/getServiceAll").then(res => {
        this.optionService = [
          { text: "Select", value: "" },
          ...res.map(type => ({
            value: type.service_id,
            text: type.title
          }))
        ];
      });
    },
    submitData() {
      if (this.validateSave) {
        this.$store
          .dispatch("SubMenu/saveSubMenu", {
            id: this.form.sub_menu_id,
            data: this.form
          })
          .then(res => {
            if (res.response_code == 200) {
              this.$emit("update", res.result);
            } else {
              Swal(res.response_msg);
            }
          })
          .catch(() => {
            Swal('','Cannot save submenu','error');
          });
      }
    },
    cancelData() {
      this.$emit("update", false);
    },
    validateSave() {
      if (!this.form.service_id) {
        Swal('','Please insert Service !','error');
        return false;
      } else if (!this.form.title_th) {
        Swal('','Please insert Menu TH !','error');
        return false;
      } else if (!this.form.title_en) {
        Swal('','Please insert Menu EN !','error');
        return false;
      } else {
        return true;
      }
    },
    deleteSubMenu() {
      this.$store
        .dispatch("SubMenu/deleteSubMenu", this.form.sub_menu_id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToSubMenuTable();
          }
        })
        .catch(() => {
          Swal('','Cannot delete menu data','error');
        });
    },
    updateMenu(val) {
      this.form.menu_id = val;
    },
    updateService(val) {
      this.form.service_id = val;
    },
    updateMenuTH(val) {
      this.form.title_th = val;
    },
    updateMenuEN(val) {
      this.form.title_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateSlugUrl(val) {
      this.form.slug_url = val;
    }
  }
};
</script>

<style scoped></style>
